import React from 'react';
import { Box, CircularProgress, Typography, IconButton } from '@mui/material';
import { Close, InsertDriveFile, CheckCircle, Error as ErrorIcon } from '@mui/icons-material';

const AttachedFiles = ({ files, onRemove }) => {
  if (!files || files.length === 0) return null;

  const getFileIcon = (status) => {
    if (status === 'uploading') {
      return <CircularProgress size={16} sx={{ color: 'primary.main' }} />;
    }
    if (status === 'ready') {
      return <CheckCircle sx={{ fontSize: 16, color: 'success.main' }} />;
    }
    if (status === 'error') {
      return <ErrorIcon sx={{ fontSize: 16, color: 'error.main' }} />;
    }
    if (status === 'pending') {
      return <InsertDriveFile sx={{ fontSize: 16, color: 'text.secondary' }} />;
    }
    return <InsertDriveFile sx={{ fontSize: 16 }} />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexWrap: 'wrap',
      gap: 1,
      px: 2,
      py: 1
    }}>
      {files.map((file) => (
        <Box
          key={file.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            bgcolor: 'background.paper',
            borderRadius: 2,
            px: 1.5,
            py: 0.75,
            border: '1px solid',
            borderColor: file.status === 'error' ? 'error.main' : 'divider',
            maxWidth: '250px'
          }}
        >
          {getFileIcon(file.status)}
          <Box sx={{ 
            flex: 1, 
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column'
          }}>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 500,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: file.status === 'error' ? 'error.main' : 'text.primary'
              }}
            >
              {file.originalName}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontSize: '0.65rem',
                color: 'text.secondary'
              }}
            >
              {formatFileSize(file.size)}
              {file.status === 'error' && ` - ${file.error}`}
            </Typography>
          </Box>
          {file.status !== 'uploading' && (
            <IconButton
              size="small"
              onClick={() => onRemove(file.id)}
              sx={{
                padding: 0.25,
                '&:hover': {
                  bgcolor: 'error.lighter',
                  color: 'error.main'
                }
              }}
            >
              <Close sx={{ fontSize: 16 }} />
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default AttachedFiles;

